export const BARCODE_TYPES = [
    'qrcode',
    'japanpost',
    'ean13',
    'ean8',
    'code39',
    'code128',
    'nw7',
    'itf14',
    'upca',
    'upce',
    'gs1datamatrix',
];
export const DEFAULT_BARCODE_BG_COLOR = '#ffffff';
export const DEFAULT_BARCODE_COLOR = '#000000';
export const DEFAULT_BARCODE_INCLUDETEXT = true;
//# sourceMappingURL=constants.js.map